import { FC, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface TransactionsMonthlyChartProps {
  data: {
    month_name: string;
    total_transactions: number;
    year?: number | null;
  }[];
  startDate?: Date | null;
  endDate?: Date | null;

}

const TransactionsMonthlyChart: FC<TransactionsMonthlyChartProps> = ({ data, startDate, endDate }) => {
  const filteredData = useMemo(() => {
    if (!startDate && !endDate) {
      return data;
    }

    return data.filter(item => {
      const monthNames = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      const monthIndex = monthNames.findIndex(m => m === item.month_name);
      
      if (monthIndex === -1) return false;
      
      const year = item.year || new Date().getFullYear();
      
      const monthStartDate = new Date(year, monthIndex, 1);
      const monthEndDate = new Date(year, monthIndex + 1, 0);

      if (startDate && endDate) {
        return monthStartDate <= endDate && monthEndDate >= startDate;
      } else if (startDate) {
        return monthEndDate >= startDate;
      } else if (endDate) {
        return monthStartDate <= endDate;
      }
      
      return true;
    });
  }, [data, startDate, endDate]);

  const displayData = filteredData.length > 0 ? filteredData : data;
  
  const categories = displayData.map(item => item.month_name);
  const seriesData = displayData.map(item => item.total_transactions);

  const options: ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: false,
        columnWidth: "55%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    title: {
      text: "Transacciones aprobadas en los ultimos meses",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      title: {
        text: "Transacciones",
      },
      labels: {
        formatter: function (value) {
          return value.toFixed(0);
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return `${value} transacciones`;
        },
      },
    },
    colors: ["#0095FF"],
    legend: {
      show: true,
      position: "bottom",
    },
  };

  const series = [
    {
      name: "Transacciones aprobadas",
      data: seriesData,
    },
  ];

  return (
    <div className="transactions-monthly-chart">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default TransactionsMonthlyChart;
